import React from "react";

import { useFormikContext } from "formik";

// When the business changes in the Redux store (e.g. a Pusher update or an ABR query
// result), sync any field the user hasn't touched back to the server value.
// Fields the user has edited (present in touchedRef) are left untouched.
// Skips the initial mount since the form is already initialised with the correct values.
export function useBusinessFormSync(
  business: Business | null | undefined,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Formik touched state structure
  touchedRef: React.MutableRefObject<any>,
): void {
  const { values, setFieldValue } = useFormikContext<Business>();

  const valuesRef = React.useRef(values);
  React.useEffect(() => {
    valuesRef.current = values;
  });

  const isFirstRenderRef = React.useRef(true);
  React.useEffect(() => {
    if (isFirstRenderRef.current) {
      isFirstRenderRef.current = false;
      return;
    }
    if (!business) return;

    (Object.keys(business) as (keyof Business)[]).forEach(key => {
      if (
        !touchedRef.current?.[key] &&
        business[key] !== valuesRef.current[key]
      ) {
        setFieldValue(key, business[key]);
      }
    });
  }, [business, setFieldValue, touchedRef]);
}
